(function () {
  const root = window.Shopify.routes.root;
  let returnFocus = null;
  let previousOverflow = '';
  let pending = false;
  const drawer = () => document.getElementById('ArchiveDrawer');
  function setCount(count) {
    const el = document.getElementById('cartCount');
    if (el) { el.textContent = count; el.dataset.count = count; el.style.display = count > 0 ? 'flex' : 'none'; }
    const button = document.getElementById('cartBtn');
    if (button) button.setAttribute('aria-label', `Shopping cart (${count} items)`);
  }
  function replace(html) {
    const next = new DOMParser().parseFromString(html, 'text/html').getElementById('ArchiveDrawer');
    if (!next) throw new Error('Unable to refresh cart. Please try again.');
    const wasOpen = !drawer().hidden;
    drawer().innerHTML = next.innerHTML;
    drawer().hidden = !wasOpen;
  }
  async function refresh() {
    const response = await fetch(root + '?sections=archive-cart-drawer', { cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to load cart. Please try again.');
    const sections = await response.json(); replace(sections['archive-cart-drawer']);
    const cartResponse = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (cartResponse.ok) setCount((await cartResponse.json()).item_count);
  }
  function show(opener) {
    returnFocus = opener || document.activeElement;
    previousOverflow = document.body.style.overflow;
    document.body.classList.add('archive-drawer-open');
    drawer().hidden = false;
    drawer().querySelector('.archive-drawer-panel').focus();
  }
  function close() {
    drawer().hidden = true; document.body.classList.remove('archive-drawer-open');
    document.body.style.overflow = previousOverflow;
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }
  function error(message) { drawer().querySelector('[data-archive-cart-error]').textContent = message; }
  window.ArchiveCart = { async open(opener) { show(opener); try { await refresh(); drawer().querySelector('.archive-drawer-panel').focus(); } catch (e) { error(e.message); } }, close };
  async function change(key, quantity) {
    if (pending) return;
    pending = true; drawer().setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['archive-cart-drawer'], sections_url: location.pathname }) });
      const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || 'Unable to update cart.');
      if (window.archiveSyncGift) { await window.archiveSyncGift(); await refresh(); }
      else { replace(data.sections['archive-cart-drawer']); setCount(data.item_count); }
      drawer().querySelector('.archive-drawer-panel').focus();
    } catch (e) { error(e.message); } finally { pending = false; drawer().removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-archive-close]')) close();
    const quantity = event.target.closest('[data-archive-quantity]');
    if (quantity) change(quantity.closest('[data-line-key]').dataset.lineKey, Number(quantity.dataset.archiveQuantity));
  });
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-archive-input]')) {
      const value = Number(event.target.value); if (Number.isInteger(value) && value >= 0) change(event.target.closest('[data-line-key]').dataset.lineKey, value);
    }
    if (event.target.matches('[data-archive-destination]')) {
      const output = event.target.closest('.archive-delivery').querySelector('[data-archive-estimate]'); output.textContent = output.dataset[event.target.value === 'local' ? 'local' : 'world'];
    }
    if (event.target.matches('[data-product-variants]')) {
      const main = event.target.closest('[data-archive-product]');
      const prices = JSON.parse(main.parentElement.querySelector('[data-archive-variant-prices]').textContent);
      const price = prices[event.target.value];
      main.querySelectorAll('[data-archive-button-price],.product-price').forEach(el => el.textContent = price);
      main.parentElement.querySelectorAll('[data-archive-sticky-price]').forEach(el => el.textContent = price);
    }
  });
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('.archive-product-form'); if (!form) return;
    event.preventDefault(); if (pending) return;
    pending = true; const buttons = document.querySelectorAll('.archive-product-form button[type=submit],[data-archive-sticky-add]'); buttons.forEach(el => el.disabled = true);
    let status = form.querySelector('[role=alert]'); if (!status) { status = document.createElement('p'); status.setAttribute('role', 'alert'); form.append(status); } status.textContent = '';
    try {
      const payload = new FormData(form); payload.set('sections', 'archive-cart-drawer'); payload.set('sections_url', location.pathname);
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: payload }); const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
      if (window.archiveSyncGift) await window.archiveSyncGift();
      replace(data.sections['archive-cart-drawer']); show(form.querySelector('button[type=submit]')); await refresh();
      drawer().querySelector('.archive-drawer-panel').focus();
    } catch (e) { status.textContent = e.message; } finally { pending = false; buttons.forEach(el => el.disabled = false); }
  });
  document.addEventListener('keydown', function (event) {
    if (!drawer() || drawer().hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key === 'Tab') {
      const focusable = [...drawer().querySelectorAll('button,a,input,select,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement.classList.contains('archive-drawer-panel'))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
})();
